import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  IRoleMain,
  MasterPages
} from "../../../commonFunctions/CommonFunctions";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import WSButton from "../../../Components/Button/WSButton";
import httpDashboard from "../../../commonFunctions/htttpClientNew";
import WSDataGridForDashboard, {
  IColumns
} from "../../../Components/DataGrid/WSDataGridForDashboard";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import http from "../../../commonFunctions/htttpClientNew";
import config from "../../../Config/config.json";
import { resetDataComponent } from "../../../StateManagement/actions";
import { IRows } from "../../../Components/Filter/WSFilterComponent";
import { HeaderList } from "../../../Components/Header/HeaderList";
export const ChequeNotIssuedList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [chequeNotIssuedlist, setChequeNotIssuedlist] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState<number>(0);
  const [reload, setReload] = useState(false);
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const source = {
    url: "Bill/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "ChequeIssued",
        operator: "eq",
        value: "false"
      }
    ],
    sort: []
  };
  useEffect(() => {
    const getBills = async () => {
      try {
        const response: any[] = await httpDashboard.get("Bill");

        if (response) {
          // 1️⃣  Add a display‑friendly flag
          const formatted = response.map((item) => ({
            ...item,
            check: item.chequeIssued ? "Yes" : "No" // ← use the real key
          }));

          // 2️⃣  Keep only the bills that actually had a cheque issued
          const notIssuedBills = formatted.filter(
            (bill) => bill.chequeIssued === false
          );

          // 4️⃣  Sum just the issued bills’ amounts
          const total = notIssuedBills.reduce(
            (sum, bill) => sum + Number(bill.amount ?? 0),
            0
          );
          setTotalSum(total);
        }
      } catch (err) {
        console.error("Error fetching bills:", err);
      }
    };

    getBills();
  }, []);

  const columnsSummary: IColumns[] = [
    {
      fieldName: "supplierName",
      header: "Name"
    },
    {
      fieldName: "invoiceNo",
      header: "Invoice No",
      type: "default"
    },
    {
      fieldName: "paymentDate",
      header: "Payment Date",
      type: "date"
    },
    {
      fieldName: "amount",
      header: "Amount",
      type: "default"
    },
    {
      fieldName: "check",
      header: "IS CHEQUE ISSUED",
      type: "default"
    }
  ];

  const transFormData = (data: any[]) => {
    if (!data) return [];
    data.forEach((item) => {
        item.name = item?.supplier?.name;
    });
    return data;
  };

  const handleSelectionChange = (response: any[]) => {
    console.log('response when change input',response)
    if (Array.isArray(response) && response.length > 0) {
      const ids = response.map((item) => item.id);
      setSelectedIds(ids);
    } else {
      setSelectedIds([]);
    }
  };

  const handleSaveClick = async () => {
    console.log("slected ids",selectedIds)
    try {
      if (selectedIds.length > 0) {
        setLoading(true);
        const request = {
          id: selectedIds
        };
        console.log('rques is',request)
        const response: any = await http.post(
          config.apiDashboardBaseUrl + "Bill/bulk-issue-cheques",
          request
        );
        console.log('response is ',response)
        if (response && response.message) {
          setLoading(false);
           await http.post(
            config.apiDashboardBaseUrl + "Bill/bulk-issue-payment",
            request
          );
          dispatch(resetDataComponent("checkNotIssueList"));
          setReload(true);
          showMessage(response.message, "success");
        }
      }
    } catch (e) {
      console.error("Error in saving:", e);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClick = () => {
    setSelectedIds([]);
    navigate("/home");
  };
  const filterRows: IRows[] = [
    {
      label: "Due Date",
      fieldName: "DueDate",
      type: "date",
      operator: "eq"
    }
  ];

  const columns: IColumns[] = [
    { header: "Supplier Name", fieldName: "name", type: "default" },
    { header: "Invoice No", fieldName: "invoiceNo", type: "default" },
    {
      header: "Amount",
      fieldName: "amount",
      type: "currency"
    },
    { header: "Invoice Date", fieldName: "invoiceDate", type: "date" },
    { header: "Due Date", fieldName: "dueDate", type: "date" },
    { header: "Category", fieldName: "category", type: "default" }
  ];
  return (
    <>
      <Grid container spacing={2}>
        <HeaderList
          id="chequeNotIssued"
          title="Cheque Not Issued"
          info={`${totalSum || 0} Total Amount`}
          type="simple"
          usage="amount"
        />
        <Grid item xs={12}>
          {/* <WSDataGridForDashboard
            id="checkIssueList"
            title="Cheque Not Issued"
            pageSize={10}
            //searchBox={{ fieldName: 'Category,InvoiceNo,Supplier.Name' }} filterFields={filterRows}
            columns={columnsSummary}
            data={chequeNotIssuedlist}
            multiSelect={true}
            onSelectionChange={handleSelectionChange}
            transFormData={transFormData}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
          /> */}

          <WSDataGridForDashboard
            id="checkNotIssueList"
            title="Check Not Issued"
            pageSize={10}
            searchBox={{ fieldName: "Category,InvoiceNo,Supplier.Name" }}
            filterFields={filterRows}
            columns={columns}
            source={source}
            transFormData={transFormData}
            multiSelect={true}
            onSelectionChange={handleSelectionChange}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
          />
        </Grid>

        {/* Button Section */}
        <Grid
          item
          xs={12}
          sx={{
            marginTop: "3rem",
            display: "flex",
            justifyContent: "flex-end",
            gap: 2
          }}
        >
          <WSButton
            id="submit"
            label="Save"
            type="button"
            className={`ws-default ${
              selectedIds.length === 0 ? "disabled" : ""
            }`}
            disabled={selectedIds.length === 0}
            size="medium"
            loading={loading}
            onClick={handleSaveClick}
          />
          <WSButton
            id="cancel"
            label="Cancel"
            type="button"
            onClick={handleCancelClick}
            size="medium"
            className="ws-cancel"
          />
        </Grid>
      </Grid>
    </>
  );
});
